import { Colors } from "baseStyles/enums/colors";
import Device from "baseStyles/enums/device";
import { SuiStylesType, useSuiStyles } from "baseStyles/useSuiStyles";
import { FlexBoxPropsType, FlexProps } from "schoolUiComponents/basic/Box/FlexBox/types";
import { InputPropsType } from "schoolUiComponents/basic/Input/types";

type PropsType = {}

type StylesType = {
    mainBox: FlexBoxPropsType;
    divider: FlexBoxPropsType;
    testimonialsBlock: FlexBoxPropsType;
    signupBlock: FlexBoxPropsType;
    socialCtasBlock?: FlexBoxPropsType;
    socialCtaBtns?: FlexBoxPropsType;
    signupFormInputBlocks?: FlexBoxPropsType;
    signupFormInputs?: FlexBoxPropsType;
    headerStyles?: FlexBoxPropsType & {hideText?: boolean};
    testimonialsContent?: FlexBoxPropsType & {noFullWidth?: boolean};
    testimonialContextText?: FlexBoxPropsType;
    tncPopup: FlexBoxPropsType;
    socialButtons?: FlexBoxPropsType;
    signupFirstDivInputs?: FlexBoxPropsType;
}

const Styles: SuiStylesType<PropsType, StylesType> = {
    [Device.types.Desktop]: ({theme}) => {
        return {
            mainBox: {
                padding: 48,
                margin: `32px auto`,
                width: 1170,
                flexDirection: FlexProps.FlexDirection.ROW
            },
            divider: {
                height: `100%`,
                width: 1
            },
            testimonialsBlock: {
                width: '42.5%',
                padding: `0 48px 0 0`
            },
            signupBlock: {
                borderLeft: `1px solid ${Colors.LIGHT_GREY_1}`,
                padding: `0 0 0 48px`
            },
            testimonialsContent: {
                alignStart: true,
                width: '100%',
                gap: 24
            },
            tncPopup: {
                width: 560,
                justifyContent: FlexProps.JustifyContent.CENTER
            },
            socialButtons: {
                width: '45%',
                margin: `0 16px 0 0`,
            },
            signupFirstDivInputs: {
                margin: `0 16px 0 0`
            }
        }
    },
    [Device.types.Tablet]: (props) => {
        return {
            mainBox: {
                padding: 24,
                margin: `2px auto`,
                width: '100%',
                maxWidth: 912,
                flexDirection: FlexProps.FlexDirection.COLUMN_REVERSE
            },
            divider: {
                width: `100%`,
                height: 1
            },
            testimonialsBlock: {
                width: `100%`,
                padding: `40px 0 0 0`
            },
            signupBlock: {
                borderLeft: null,
                padding: `0 0 40px 0`,
                borderBottom: `1px solid ${Colors.LIGHT_GREY_1}`,
            },
            testimonialsContent: {
                alignStart: true,
                width: '100%',
                gap: 24,
                noFullWidth: true,
                flexDirection: FlexProps.FlexDirection.ROW
            },
            testimonialContextText: {
                alignStart: true,
                gap: 24,
                width: '75%'
            },
            tncPopup: {
                width: 560,
                justifyContent: FlexProps.JustifyContent.CENTER
            }
        }
    },
    [Device.types.Mobile]: (props) => {
        return {
            mainBox: {
                padding: 24,
                margin: `2px auto`,
                width: `100%`,
                flexDirection: FlexProps.FlexDirection.COLUMN_REVERSE
            },
            divider: {
                width: `100%`,
                height: 1
            },
            testimonialsBlock: {
                width: `100%`,
            },
            signupBlock: {
                borderLeft: null
            },
            socialCtasBlock: {
                flexDirection: FlexProps.FlexDirection.COLUMN
            },
            socialCtaBtns: {
                fullWidth: true
            },
            signupFormInputBlocks: {
                flexDirection: FlexProps.FlexDirection.COLUMN,
                width: '100%'
            },
            signupFormInputs: {
                fullWidth: true
            },
            headerStyles: {
                hideText: true
            },
            testimonialsContent: {
                alignStart: true,
                width: '100%',
                gap: 24,
                noFullWidth: true,
                flexDirection: FlexProps.FlexDirection.COLUMN
            },
            testimonialContextText: {
                alignStart: true,
                gap: 24,
                width: '100%'
            },
            tncPopup: {
                width: 300,
                justifyContent: FlexProps.JustifyContent.FLEX_START
            },
            socialButtons: {
                width: '100%',
                margin: `0 0 16px 0`,
            },
            signupFirstDivInputs: {
                margin: `0 0 16px 0`
            }
        }
    }
}

const TeacherSignupStyles = useSuiStyles(Styles);

export default TeacherSignupStyles;